import { useContext, useEffect } from "react";

import { MktgDataContext } from "@swa-ui/application";
import { useLocation } from "@swa-ui/browser";

import { ROUTES } from "./defines/routes";

export const useDestinationsPageAnalytics = () => {
  const { pathname } = useLocation();
  const { setAdobePageData } = useContext(MktgDataContext);

  useEffect(() => {
    if (pathname === ROUTES.destinations) {
      const adobeAnalyticsObj = {
        eventinfo: { eventtype: "other" },
      };

      setAdobePageData(adobeAnalyticsObj, "destinationsPage");
    }
  }, [pathname]);
};
